import Vue from 'vue'
export default new Vue()

const eventHub = new Vue()

Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/Pages/components/eventHub.js